import { roundDec } from "./utils";

export const EMISSION_FACTOR = {
  harvest: {
    cropType: {
      potato: 0.145,
    },
  },
  transport: {
    vehicle: {
      diesel: 0.736, // kg CO2e per km of transport
      electricRenewable: 0, // no emissions assumed
      electricStandard: 0.484, // kg CO2e per km of transport
      HFO: 3.11,
    },
  },
  storage: {
    traditional: 0,
    coldStorage: 0.88,
  },
  processing: {
    electrictyFactor: 0.887,
  },
};

export const getHarvestEmissions = (
  cropType,
  cropRotation,
  dripIrrigation,
  fertilizer,
  stubbleBurn,
  weight,
  electricityUsed,
  diselUsed,
) => {
  // cropRotation : (Boolean) emissions reduce depending on what new crop is put ~ 10-15%
  // dripIrrigation : (Boolean) more effectively use water --> implement when water field is used
  // fertilizer : (amnt fertilizer used, kg) amnt x 10
  // stubbleBurn : (kg of crop burned) amnt x 92.53
  // electricity : (kW/h) amnt of elect x 0.85 --> 0.9
  // diselUsed : (L of disel) liters x 2.5 --> 3.5
  const rotationReduction = cropRotation ? 0.85 : 1;

  const fertilizerEmissions = fertilizer * 10;
  const stubbleBurnEmissions = stubbleBurn * 92.53;
  const electricalEmissions = electricityUsed * 0.85;
  const diselEmissions = diselUsed * 3;
  const emission =
    rotationReduction *
    (fertilizerEmissions +
      stubbleBurnEmissions +
      electricalEmissions +
      diselEmissions);
  return roundDec(emission);
};

export const getTransferEmissions = (transportType, distance) => {
  const emission =
    EMISSION_FACTOR["transport"]["vehicle"][transportType] * distance;
  return roundDec(emission);
};

export const getStorageEmissions = (
  storageType,
  electrictyUsed,
  additionalEmissions = 0,
) => {
  const emission =
    EMISSION_FACTOR["storage"][storageType] * electrictyUsed +
    additionalEmissions;
  return roundDec(emission);
};

export const getProcessingEmissions = (
  electrictyUsed,
  additionalEmissions = 0,
) => {
  const emission =
    EMISSION_FACTOR["processing"]["electrictyFactor"] * electrictyUsed +
    additionalEmissions;
  return roundDec(emission);
};
